import { uniqueId } from "lodash";
import { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { withLocalize } from "react-localize-redux";

const ValuesInput = ({
  values,
  onChange,
  label,
  onDelete,
  onAdd,
  translate,
}) => {
  const [newValue, setNewValue] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [id] = useState(uniqueId("input-"));

  const handleChange = (e) => {
    if (e.key === "Enter" && newValue) {
      onAdd(newValue, () => setNewValue(""));
    }
  };

  return (
    <div
      className={`ValuesInput input-group fieldset bg-white position-relative d-flex flex-column align-items-start w-100 ${
        isActive ? `input-active` : ``
      }`}
    >
      <label
        className="headTitle text-secondary fw-bold mb-0 ms-2 px-1 position-absolute"
        htmlFor={id}
      >
        {label}
      </label>
      {values.map((value, i) => (
        <div
          className="values-input w-100 rounded-0 m-0 position-relative d-flex align-items-center"
          key={i}
        >
          <input
            id={id}
            name={`values[i]-${id}`}
            value={value}
            onChange={(e) => onChange(e.target.value, i)}
            className="input form-control"
            onFocus={() => setIsActive(true)}
            onBlur={() => {
              if (!value) {
                onDelete(i);
                return;
              }
              setIsActive(false);
            }}
          />
          <div className="position-absolute remove-button" role="button">
            <AiFillCloseCircle onClick={() => onDelete(i)} />
          </div>
        </div>
      ))}
      <div className="values-input w-100 rounded-0 m-0 position-relative">
        <input
          id={id}
          name={`values[${values.length}]-${id}`}
          value={newValue}
          placeholder={translate(
            "form_templates.template_structure.values_placeholder"
          )}
          title={translate(
            "form_templates.template_structure.values_placeholder"
          )}
          className="input form-control"
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          onKeyDown={(e) => handleChange(e)}
          onChange={(e) => setNewValue(e.target.value)}
        />
      </div>
    </div>
  );
};

export default withLocalize(ValuesInput);
